<template>
  <div class="layout_outer">
    <header>
      <el-page-header class="flex align_center" @back="$router.go(-1)" :content="title" />
    </header>
    <div class="main">
      <div class="content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    backObj () {
      return this.$store.state.outer.backObj
    }
  }
}
</script>
<style lang="scss" scoped>
  .layout_outer {
    width: 100%;
    height: 100%;
    overflow: auto;
    & > header {
      display: flex;
      align-items: center;
      height: 70px;
      background-color: #F3F6F9;
      padding-left: 16.93%;
    }
    .main {
      flex: 1;
      // 只有设置了flex 才把其下的content 变成可伸缩的盒子
      display: flex;
      justify-content: center;
      // 1920 - 1280 = 640 / 2 = 320 / 1920 * 100 = 16.7%
      padding: 0 16.7%;
      overflow: auto;
      .content {
        width: 100%;
        // 因为有个滚动条的误差，为了保证1200的内容的宽 少给个20px
        padding: 40px 20px;
        // width: 1280px;
        // padding: 40px 40px;
        overflow: auto;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/outer/index.vue